import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container-full-1 bg-grey-50" }
const _hoisted_2 = { class: "s20 widget flex align-items-center px-1 py-5" }
const _hoisted_3 = { class: "s2_mobile h-100p px-7" }
const _hoisted_4 = { class: "rounded-100 overflow-hidden item active" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "s4_mobile h-100p px-2" }
const _hoisted_7 = { class: "s3_mobile h-100p px-2" }
const _hoisted_8 = { class: "font-normal mb-5" }
const _hoisted_9 = { class: "s4_mobile h-100p px-3" }
const _hoisted_10 = { class: "font-normal" }
const _hoisted_11 = { class: "text-2xl" }
const _hoisted_12 = { class: "s20 widget px-6 pt-8 pb-2" }
const _hoisted_13 = { class: "s20 gap-6 px-4 pb-6 collapse-content active" }
const _hoisted_14 = { class: "s20 flex gap-3 mb-2" }
const _hoisted_15 = { class: "form-field-split my-4" }
const _hoisted_16 = { class: "form-field-floating reactive search sm" }
const _hoisted_17 = { class: "form-field-split my-4" }
const _hoisted_18 = { class: "form-field-floating reactive sm" }
const _hoisted_19 = { class: "form-field-floating reactive sm" }
const _hoisted_20 = { class: "form-field-split my-4" }
const _hoisted_21 = { class: "form-field-floating reactive sm" }
const _hoisted_22 = { class: "form-field-floating reactive sm" }
const _hoisted_23 = { class: "s20 flex gap-3 mb-5" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "s8" }
const _hoisted_26 = {
  key: 1,
  class: "text-center"
}

import { useRoute } from 'vue-router';
    import { inject, onMounted, reactive, ref, toRaw } from 'vue';
    import axios from 'axios';
import moment from 'moment';
import { formatDateFrench } from '@/utils';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'UsersUtilisationView',
  setup(__props) {

    const BACKEND_URL = inject('BACKEND_URL');
    const route = useRoute();
    const startupinfos: any = route.meta.startup_datas;
    const user: any = startupinfos.user;
    const loading = ref(false); const errorMessage = ref('');
    const loadingListing = ref(false); const errorMessageListing = ref('');
    const queryParams = reactive({
        pageNumber: 1,
        borneInf: '',
        borneSup: '',
        search: '',
        banque_id: null as any,
    });
    const dateParams = reactive({
        dateInf: '',
        heureInf: '',
        dateSup: '',
        heureSup: '',
    });
    const pagination = reactive({
        total: 0,
        per_page: 10,
        last_page: 1
    });
    const itemsList = ref([] as any[]);

    onMounted(() => {
        doListTransactions();
    });

    async function doListTransactions() {
        try {
            loadingListing.value = true;
            errorMessageListing.value = '';
            const queryParamsRaw = toRaw(queryParams);
            const queryString = new URLSearchParams(Object.fromEntries(Object.entries(queryParamsRaw).map(([k,v]) => [k, String(v)]))).toString();
            const httpResponse = await axios.get(`/backoffice/users/${user.id}/utilisation/list_transactions?${queryString}`);
            itemsList.value = httpResponse.data.data;
            pagination.total = httpResponse.data.total;
            pagination.per_page = httpResponse.data.per_page;
            pagination.last_page = httpResponse.data.last_page;
        } catch (error: any) {
            errorMessageListing.value = error.message;
        } finally {
            loadingListing.value = false;
        }
    }

    function onDateParamsChanged() {
        let borneInf: any = null;
        if (dateParams.dateInf) {
            borneInf = dateParams.dateInf;
            if (dateParams.heureInf) { borneInf += `T${dateParams.heureInf}`; }
            const borneInfMoment = moment(borneInf);
            if (borneInfMoment.isValid()) {
                queryParams.borneInf = borneInfMoment.format('YYYY-MM-DD HH:mm');
            }
        }

        let borneSup: any = null;
        if (dateParams.dateSup) {
            borneSup = dateParams.dateSup;
            if (dateParams.heureSup) { borneSup += `T${dateParams.heureSup}`; }
            const borneSupMoment = moment(borneSup);
            if (borneSupMoment.isValid()) {
                queryParams.borneSup = borneSupMoment.format('YYYY-MM-DD HH:mm');
            }
        }
        
        doListTransactions();
    }

    function onPaginate(pageNumber: number) {
        queryParams.pageNumber = pageNumber;
        doListTransactions();
    }

    function onSelectBanque(banque_id: number) {
        queryParams.banque_id = banque_id;
        doListTransactions();
    }

return (_ctx: any,_cache: any) => {
  const _component_custom_pagination = _resolveComponent("custom-pagination")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[23] || (_cache[23] = _createStaticVNode("<div class=\"page-space-40\"></div><h4 class=\"s7 font-semibold px-3 pb-5\">Membre / Utilisation <span class=\"text-sm text-grey-500\"></span></h4><div class=\"s13 flex-right gap-3 mt--2 mb-5 px-5\"><span class=\"btn shadow-200 white2\">Wallet / Utilisation</span><span class=\"btn shadow-200 light2 border-none\">Transactions</span></div>", 3)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            src: !!_unref(user).photo_url ? _unref(user).photo_url : '/assets/users_avatar/600w/user.jpg',
            width: "100%"
          }, null, 8, _hoisted_5)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _cache[6] || (_cache[6] = _createElementVNode("h3", { class: "mb-2" }, "C788PMKJ", -1)),
        _createElementVNode("h4", null, _toDisplayString(_unref(user).nom + ' ' + _unref(user).prenom), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("h4", _hoisted_8, _toDisplayString(_unref(user).collectivite?.nom), 1),
        _cache[7] || (_cache[7] = _createElementVNode("span", { class: "tag-state warning stroke" }, "En cours", -1)),
        _cache[8] || (_cache[8] = _createElementVNode("span", { class: "tag-state notif stroke" }, "Actif", -1))
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("h4", _hoisted_10, [
          _cache[9] || (_cache[9] = _createTextVNode(" Date de fin de souscription ", -1)),
          _cache[10] || (_cache[10] = _createElementVNode("br", { class: "mb-2" }, null, -1)),
          _createElementVNode("b", _hoisted_11, _toDisplayString(_unref(user).souscription ? _unref(formatDateFrench)(_unref(user).souscription.date_fin) : '-'), 1)
        ])
      ]),
      _cache[11] || (_cache[11] = _createElementVNode("div", { class: "s7_mobile h-100p px-5" }, [
        _createElementVNode("div", {
          class: "h-60 rounded-100 position-relative",
          style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
        }, [
          _createElementVNode("div", { class: "widget-floating py-0 text-xl flex-right" }, "Utilisation"),
          _createElementVNode("div", {
            class: "h-100p flex align-items-center justify-content-left rounded-100 text-2xl px-5 bg-pop-green",
            style: {"width":"25%"}
          }, " 25% ")
        ])
      ], -1))
    ]),
    _cache[24] || (_cache[24] = _createStaticVNode("<div class=\"clear-both h-20\"></div><div class=\"s20 widget px-6 pt-8 pb-2\"><div class=\"s10 mt--4 ml--4 mb-5 collapse-open active\"><span class=\"px-5 py-4 bg-color-black rounded-100 text-xl\"><img src=\"/icons/icon-panel-open.svg\" class=\"size-xs icon-neutral mr-2 collapse-icon-open\" alt=\"\"><img src=\"/icons/icon-panel-close.svg\" class=\"size-xs icon-neutral mr-2 collapse-icon-close\" alt=\"\"> Wallet / Utilisation </span></div><div class=\"s10 mt--5-5 flex-right\"></div><div class=\"s20 gap-6 px-5 pb-8 collapse-content active\"><div class=\"clear-both h-10\"></div><div class=\"flex items-center gap-6\"><div class=\"s7\"><h5 class=\"flex gap-3 secondary-font font-semibold text-grey-700\"><div class=\"circle-medium bg-color-1000\"></div> Solde </h5><h1 class=\"secondary-font font-semibold text-grey-900 my-2 text-5xl\">184 350 F</h1><h5 class=\"secondary-font font-semibold text-grey-700 mb-4\">92%</h5><div class=\"h-40 rounded-100 position-relative overflow-hidden\" style=\"width:100%;background-color:rgba(var(--color-black-rgb), 0.1);\"><div class=\"h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-color-1000 text-white\" style=\"width:92%;\"> 92% </div></div></div><div class=\"s7\"><h5 class=\"flex gap-3 secondary-font font-semibold text-grey-700\"><div class=\"circle-medium bg-purple\"></div> Montant Utilisé </h5><h1 class=\"secondary-font font-semibold text-grey-900 my-2 text-5xl\">52 350 F</h1><h5 class=\"secondary-font font-semibold text-grey-700 mb-4\">56.4%</h5><div class=\"h-40 rounded-100 position-relative overflow-hidden\" style=\"width:100%;background-color:rgba(var(--color-black-rgb), 0.1);\"><div class=\"h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-purple text-white\" style=\"width:56.4%;\"> 56.4% </div></div></div><div class=\"s6\"><h5 class=\"flex gap-3 secondary-font font-semibold text-grey-700\"><div class=\"circle-medium bg-green-light\"></div> Dernier décaissement </h5><h1 class=\"secondary-font font-semibold text-grey-900 my-2 text-5xl\">184 350 F</h1><h5 class=\"secondary-font font-semibold text-grey-700 mb-4\">100%</h5><div class=\"h-40 rounded-100 position-relative overflow-hidden\" style=\"width:100%;background-color:rgba(var(--color-black-rgb), 0.1);\"><div class=\"h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-green-light\" style=\"width:100%;\"> 100% </div></div></div></div></div></div><div class=\"clear-both h-5\"></div><div class=\"step vertical bg-grey-500 ml-auto mr-auto\"></div><div class=\"clear-both h-5\"></div>", 5)),
    _createElementVNode("div", _hoisted_12, [
      _cache[22] || (_cache[22] = _createStaticVNode("<div class=\"s10 mt--4 ml--4 mb-5 collapse-open active\"><span class=\"px-5 py-4 bg-color-black rounded-100 text-xl\"><img src=\"/icons/icon-panel-open.svg\" class=\"size-xs icon-neutral mr-2 collapse-icon-open\" alt=\"\"><img src=\"/icons/icon-panel-close.svg\" class=\"size-xs icon-neutral mr-2 collapse-icon-close\" alt=\"\"> Transactions </span></div><div class=\"s10 mt--5-5 flex-right\"><button class=\"btn lg py-3 black\"><img src=\"/icons/icon-pdf.svg\" class=\"btn-icon\" alt=\"\"><span>Exporter en PDF</span></button><button class=\"btn lg py-3 black\"><img src=\"/icons/icon-excel.svg\" class=\"btn-icon\" alt=\"\"><span>Exporter en Excel</span></button></div><div class=\"clear-both h-5\"></div>", 3)),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-input",
                id: "filters_search",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((queryParams.search) = $event)),
                placeholder: "",
                onKeyup: _withKeys(doListTransactions, ["enter"])
              }, null, 544), [
                [_vModelText, queryParams.search]
              ]),
              _cache[12] || (_cache[12] = _createElementVNode("label", { for: "date1" }, "Référence de transaction", -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _withDirectives(_createElementVNode("input", {
                type: "date",
                class: "form-input",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dateParams.dateInf) = $event)),
                placeholder: "",
                onChange: onDateParamsChanged
              }, null, 544), [
                [_vModelText, dateParams.dateInf]
              ]),
              _cache[13] || (_cache[13] = _createElementVNode("label", { for: "date1" }, "Date <=", -1))
            ]),
            _cache[15] || (_cache[15] = _createElementVNode("hr", { class: "hr sm" }, null, -1)),
            _createElementVNode("div", _hoisted_19, [
              _withDirectives(_createElementVNode("input", {
                type: "date",
                class: "form-input",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dateParams.dateSup) = $event)),
                placeholder: "",
                onChange: onDateParamsChanged
              }, null, 544), [
                [_vModelText, dateParams.dateSup]
              ]),
              _cache[14] || (_cache[14] = _createElementVNode("label", { for: "date2" }, "Date >=", -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _withDirectives(_createElementVNode("input", {
                type: "time",
                class: "form-input",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dateParams.heureInf) = $event)),
                placeholder: "",
                onChange: onDateParamsChanged
              }, null, 544), [
                [_vModelText, dateParams.heureInf]
              ]),
              _cache[16] || (_cache[16] = _createElementVNode("label", { for: "time1" }, "Heure <=", -1))
            ]),
            _cache[18] || (_cache[18] = _createElementVNode("hr", { class: "hr sm" }, null, -1)),
            _createElementVNode("div", _hoisted_22, [
              _withDirectives(_createElementVNode("input", {
                type: "time",
                class: "form-input",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((dateParams.heureSup) = $event)),
                placeholder: "",
                onChange: onDateParamsChanged
              }, null, 544), [
                [_vModelText, dateParams.heureSup]
              ]),
              _cache[17] || (_cache[17] = _createElementVNode("label", { for: "time1" }, "Heure >=", -1))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("span", {
            class: _normalizeClass(["btn", {'light': queryParams.banque_id == null, 'light2': queryParams.banque_id != null}])
          }, "Tout", 2),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(user).cartes, (item, index) => {
            return (_openBlock(), _createElementBlock("span", {
              class: _normalizeClass(["btn", {'light': queryParams.banque_id == item.banque.id, 'light2': queryParams.banque_id != item.banque.id}]),
              key: index,
              onClick: ($event: any) => (onSelectBanque(item.banque.id))
            }, _toDisplayString(item.banque.nom), 11, _hoisted_24))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_25, [
          (itemsList.value.length > 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemsList.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "flex gap-6 mb-4",
                    key: index
                  }, [...(_cache[19] || (_cache[19] = [
                    _createStaticVNode("<div class=\"square-xl px-4 py-4\" style=\"background-color:rgba(0, 185, 172, 0.08);\"><img src=\"/icons/icon-trans-recharger.svg\" width=\"100%\" class=\"icon-neutral\"></div><div class=\"s13 mt-2\"><h6 class=\"secondary-font font-semibold mb-1\">Rechargement de ma carte a partir de mon wallet</h6><p class=\"secondary-font text-sm text-grey-600 mb-2\">12 Mars 2024 à 14:32 - TCE441454</p></div><h5 class=\"s5 secondary-font text-right mt-2 text-green\">+ 50 000 F</h5>", 3)
                  ]))]))
                }), 128)),
                _createVNode(_component_custom_pagination, {
                  modelValue: queryParams.pageNumber,
                  "onUpdate:modelValue": [
                    _cache[5] || (_cache[5] = ($event: any) => ((queryParams.pageNumber) = $event)),
                    onPaginate
                  ],
                  total: pagination.total,
                  "per-page": pagination.per_page,
                  last_page: pagination.last_page
                }, null, 8, ["modelValue", "total", "per-page", "last_page"])
              ], 64))
            : _createCommentVNode("", true),
          (itemsList.value.length == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [...(_cache[20] || (_cache[20] = [
                _createElementVNode("h6", { class: "secondary-font font-semibold mb-1" }, "Aucune transaction enregistrée", -1)
              ]))]))
            : _createCommentVNode("", true)
        ]),
        _cache[21] || (_cache[21] = _createStaticVNode("<div class=\"s2 flex-center\"><hr class=\"hr-vertical h-500\"></div><div class=\"s10 px-4 mt-2\"><div class=\"s10\"><h5 class=\"flex gap-3 secondary-font font-semibold text-grey-700\"><div class=\"circle-medium bg-color-1000\"></div> Décaissement </h5><h1 class=\"secondary-font font-semibold text-grey-900 my-2 text-5xl\">184 350 F</h1><h5 class=\"secondary-font font-semibold text-grey-700 mb-4\">+5.4%</h5></div><div class=\"s10\"><h5 class=\"flex gap-3 secondary-font font-semibold text-grey-700\"><div class=\"circle-medium bg-purple\"></div> Utilisation </h5><h1 class=\"secondary-font font-semibold text-grey-900 my-2 text-5xl\">52 350 F</h1><h5 class=\"secondary-font font-semibold text-grey-700 mb-4\">56.4%</h5></div><div class=\"clear-both h-30\"></div><img src=\"/images/graph-transaction.png\" alt=\"Transaction Graph\" width=\"100%\"></div>", 2))
      ])
    ]),
    _cache[25] || (_cache[25] = _createElementVNode("div", { class: "clear-both h-80" }, null, -1))
  ]))
}
}

})